import React, {
    useState,
    useEffect,
    useCallback,
  } from "react";
  import { Button, Form } from "react-bootstrap";
  import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
  } from "../../../../_metronic/_partials/controls/Card";
  import Select, { createFilter } from "react-select";
  import Loader from "react-loader-spinner";
  import jsPDF from "jspdf";
  import html2canvas from "html2canvas";
  import * as XLSX from "xlsx";
  import {
    getRequest,
    Uri_GetFacility,
    getRequestQry,
    Uri_GetFacilityResidentWoundDocumentation,
  } from "../../../General/api";
  import {
    GetDateString,
    calculatePushScore,
    exudate,
    showSuccessAlertAutoClose,
  } from "../../../General/common";
  import moment from "moment";
  import flatpickr from "flatpickr";
  import { WithGroupedWoundReports } from "./withGroupedWoundReports";
  
  export const FacilityReport = (props) => {
    const [facilitySelected, setFacilitySelected] = useState(null);
    const [formValidated, setFormValidated] = useState(false);
    const [facilityList, setFacilityList] = useState([]);
    const [IsLoading, setIsLoading] = useState(false);
    const [showReport, setShowReport] = useState(false);
    const [woundEvaluations, setWoundEvaluations] = useState();
      const [datePicker, setDatePicker] = useState(null);
      const [fromDatePicker, setFromDatePicker] = useState(null); 
    const [isPrinting, setIsPrinting] = useState(false);
  
    const successStatusCode = 200;
    const defaultCloseModalTimeout = 3000;
  
    const acquisitionEnum = {
      1: "Admitted",
      2: "Acquired",
      3: "Closed",
      4: "Reoccurring",
    };
  
    const orientationEnum = {
      LEFT: 2,
      RIGHT: 1,
    };
  
    const getHorizontalOrientation = (orientation) => {
      switch (orientation) {
        case orientationEnum.LEFT:
          return "Left - ";
        case orientationEnum.RIGHT:
          return "Right - ";
        default:
          return "";
      }
    };
  
    const buildWoundBedDescription = (wound) => {
      const parts = [];
      if (wound.granulationPerc > 0) {
        parts.push(`Granulation %: ${wound.granulationPerc}`);
      }
      if (wound.hyperGranulationPerc > 0) {
        parts.push(`HyperGranulation %: ${wound.hyperGranulationPerc}`);
      }
      if (wound.sloughPerc > 0) {
        parts.push(`Slough %: ${wound.sloughPerc}`);
      }
      if (wound.necroticPerc > 0) {
        parts.push(`Necrotic/Eschar %: ${wound.necroticPerc}`);
      }
      if (wound.epithelialPerc > 0) {
        parts.push(`Epithelial %: ${wound.epithelialPerc}`);
      }
      if (wound.musclePerc > 0) {
        parts.push(`Muscle, Tendon or Bone %: ${wound.musclePerc}`);
      }
      if (wound.otherPerc > 0) {
        parts.push(`${wound.otherWoundDesc} %: ${wound.otherPerc}`);
      }
      if (wound.wounSurroundingSkinName) {
        parts.push(`Surrounding Skin: ${wound.wounSurroundingSkinName}`);
      }
      if (
        wound.wounSurroundingSkinName === "Other" &&
        wound.otherSurroundingSkin
      ) {
        parts.push(`Surrounding Skin Other: ${wound.otherSurroundingSkin}`);
      }
      if (wound.woundEdgesName) {
        parts.push(`Wound Edges: ${wound.woundEdgesName}`);
      }
      return parts.filter(Boolean).join(" | ");
    };
  
  
    const datePickerRef = useCallback((node) => {
      if (node !== null) {
        setDatePicker(
          flatpickr(node, {
            allowInput: true,
            mode: "single",
            altInput: true,
          })
        );
      }
    }, []);

      const fromDatePickerRef = useCallback((node) => {
          if (node !== null) {
              setFromDatePicker(
                  flatpickr(node, {
                      allowInput: true,
                      mode: "single",
                      altInput: true,
                  })
              );
          }
      }, []);
  
    useEffect(() => {
      getRequest(`${Uri_GetFacility}?isAssessmentView=1`)
        .then((res) => {
          const data = res.data;
          if (
            data.statusCode === successStatusCode &&
            data.result != null &&
            data.result.length > 0
          ) {
            setFacilityList(
              data.result
                .map((facility) => ({
                  value: facility.id,
                  label: facility.facilityName,
                }))
                .sort((a, b) => a.label.localeCompare(b.label))
            );
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          showSuccessAlertAutoClose(
            "Sorry, an error has occurred",
            "warning",
            "warning!",
            defaultCloseModalTimeout
          );
        });
    }, []);
  
    const handleSubmit = (event) => {
      event.preventDefault();
  
      const dateFormatted = moment(datePicker.selectedDates[0]).format(
        "YYYY-MM-DD"
        );
        const fromDateFormatted = moment(fromDatePicker.selectedDates[0]).format("YYYY-MM-DD");
      getRequestQry(
        Uri_GetFacilityResidentWoundDocumentation,
          `?facilityId=${facilitySelected.value}&fromDate=${fromDateFormatted}&toDate=${dateFormatted}`
      )
        .then((res) => {
          const data = res.data;
          if (data.statusCode === 200) {
            if (data.result != null) {
              setWoundEvaluations(data.result);
              setShowReport(true);
            } else {
              showSuccessAlertAutoClose(
                "Record not found",
                "warning",
                "warning!",
                defaultCloseModalTimeout
              );
              setShowReport(false);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          showSuccessAlertAutoClose(
            "Sorry, an error has occurred",
            "warning",
            "warning!",
            defaultCloseModalTimeout
          );
        });
    };
  
    const handleClearFilters = (e) => {
      e.preventDefault();
      e.stopPropagation();
  
      setFacilitySelected(null);
        datePicker.clear();
        fromDatePicker.clear();
      setWoundEvaluations(null);
      setShowReport(false);
      setFormValidated(false);
    };
  
    const renderWoundForm = () => {
      return (
        <>
          {!IsLoading ? (
            <form onSubmit={(e) => handleSubmit(e)}>
              <div className="row">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label" for="FacilityName">
                      Facility Name
                    </label>
                    <Select
                      options={facilityList}
                      id="facilityId"
                      name="facilityId"
                      required
                      isSearchable
                      isClearable
                      filterOption={createFilter({ matchFrom: "start" })}
                      onChange={(e) => setFacilitySelected(e)}
                      value={facilitySelected}
                    />
                  </div>
                          </div>
                          <div className="col-lg-4">
                              <div className="form-group">
                                  <label className="form-label" htmlFor="fromDatePicker">
                                      From Date
                                  </label>
                                  <input
                                      type="date"
                                      id="fromDatePicker"
                                      placeholder="Select..."
                                      required
                                      className="form-control form-control-md"
                                      ref={fromDatePickerRef}
                                  />
                              </div>
                          </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label" forHtml="datePicker">
                      To Date
                    </label>
                    <input
                      type="date"
                      id="datePicker"
                      placeholder="Select..."
                      required
                      className="form-control form-control-md"
                      ref={datePickerRef}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end py-3">
                <Button
                  variant="success"
                  className="mr-5 px-10"
                  size="sm"
                  type="submit"
                >
                  Search Report
                </Button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={(e) => handleClearFilters(e)}
                >
                  Clear filter
                </button>
              </div>
            </form>
          ) : (
            <div className="d-flex justify-content-center">
              <Loader type="Puff" color="#00BFFF" height={50} width={50} />
            </div>
          )}
        </>
      );
    };
  
    async function PrintElem() {
      setIsPrinting(true);
      let doc = new jsPDF("landscape", "pt", "a4", false);
  
      const elm = document.querySelectorAll("div[id^='printThis']");
      for await (const item of elm) {
        await html2canvas(item, { scale: 2 }).then((canvasItem) => {
          const pixelHeight = 840 * 2;
          for (let i = 0; i <= item.clientHeight * 2; i += pixelHeight) {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = canvasItem.width;
            canvas.height = pixelHeight;
            ctx.drawImage(
              canvasItem,
              0,
              i,
              canvasItem.width,
              pixelHeight,
              0,
              0,
              canvasItem.width,
              pixelHeight
            );
            const imgData = canvas.toDataURL("image/png");
            doc.addImage(imgData, "PNG", 10, 30, 822, 0, undefined, "FAST");
            if (i + pixelHeight < item.clientHeight * 2) {
              doc.addPage();
            }
          }
        });
  
        if (Array.from(elm).indexOf(item) !== elm.length - 1) {
          await doc.addPage();
        }
      }
  
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFont("Poppins", "normal", "bold");
      doc.setFontSize(8);
      doc.setTextColor(112, 108, 108);
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(
          "Page " + i + " of " + pageCount,
          doc.internal.pageSize.width - 50,
          doc.internal.pageSize.height - 20
        );
      }
  
      doc.save(`${facilitySelected.label} - Wound Report.pdf`);
      setIsPrinting(false);
    }
  
    const handleExportExcel = () => {
      if (!woundEvaluations || woundEvaluations.length === 0) {
        showSuccessAlertAutoClose(
          "Record not found",
          "warning",
          "warning!",
          defaultCloseModalTimeout
        );
        return;
      }
  
      const exportHeaders = [
        "Facility Name",
        "Wound Type",
        "From Date",
        "To Date",
        "Resident Name",
        "Unit/Room",
        "Date First Observed",
        "Admitted",
        "Acquired",
        "Closed",
        "Reoccurring",
        "Location",
        "Type",
        "Length",
        "Width",
        "Depth",
        "Stage/Thickness",
        "Exudate",
        "Push",
        "Wound Bed Description",
        "Treatment",
      ];

      const rows = [];
      woundEvaluations.forEach((report) => {
        const fromDate = GetDateString(report.fromDate);
        const toDate = GetDateString(report.toDate);
        const woundType = report.woundType || "";
        const facilityName = report.facilityName || facilitySelected?.label || "";
  
        (report.woundEvaluationDetail || []).forEach((wound) => {
          const exudateMap = {
            Light: exudate.light,
            Moderate: exudate.moderate,
            Heavy: exudate.heavy,
          };
          const exudateId = exudateMap[wound.exudateAmountName] || 0;
          const horizontalOrientation = getHorizontalOrientation(
            wound.orientationLeftRight
          );
          const locationParts = [];
          if (horizontalOrientation) {
            locationParts.push(horizontalOrientation.trim());
          }
          if (wound.woundBodyRegion) {
            locationParts.push(wound.woundBodyRegion);
          }
          if (wound.woundLocation) {
            locationParts.push(wound.woundLocation);
          }
  
          rows.push({
            "Facility Name": facilityName,
            "Wound Type": woundType,
            "From Date": fromDate,
            "To Date": toDate,
            "Resident Name": wound.residentName || "",
            "Unit/Room": wound.roomUnit || "N/A",
            "Date First Observed": wound.dateFirstObserved
              ? GetDateString(wound.dateFirstObserved)
              : "",
            Admitted: wound.acquisition === acquisitionEnum[1] ? 1 : 0,
            Acquired: wound.acquisition === acquisitionEnum[2] ? 1 : 0,
            Closed: wound.acquisition === acquisitionEnum[3] ? 1 : 0,
            Reoccurring: wound.acquisition === acquisitionEnum[4] ? 1 : 0,
            Location: locationParts.join(" / "),
            Type: wound.woundType || "",
            Length: wound.woundLength ?? "",
            Width: wound.woundWidth ?? "",
            Depth: wound.woundDepth ?? "",
            "Stage/Thickness": wound.woundThicknessName || "",
            Exudate: wound.exudateAmountName || "",
            Push: calculatePushScore(
              (wound.woundLength || 0) * (wound.woundWidth || 0),
              exudateId,
              wound.fkWoundSevereTissueTypeId
            ),
            "Wound Bed Description": buildWoundBedDescription(wound),
            Treatment: wound.treatment || "",
          });
        });
      });
  
      if (rows.length === 0) {
        showSuccessAlertAutoClose(
          "Record not found",
          "warning",
          "warning!",
          defaultCloseModalTimeout
        );
        return;
      }
  
      try {
        const worksheet = XLSX.utils.json_to_sheet(rows, {
          header: exportHeaders,
        });
        const columnWidths = exportHeaders.map((header) => ({
          wch: Math.max(header.length, 12),
        }));
        rows.forEach((row) => {
          exportHeaders.forEach((header, index) => {
            const value = row[header] ?? "";
            const cellLength = String(value).length;
            if (cellLength + 2 > columnWidths[index].wch) {
              columnWidths[index].wch = Math.min(cellLength + 2, 60);
            }
          });
        });
        worksheet["!cols"] = columnWidths;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Wound Report");
        const fileBaseName = facilitySelected?.label || "Facility";
        XLSX.writeFile(workbook, `${fileBaseName} - Wound Report.xlsx`);
      } catch (error) {
        console.error(error);
        showSuccessAlertAutoClose(
          "Sorry, an error has occurred",
          "warning",
          "warning!",
          defaultCloseModalTimeout
        );
      }
    };
  
    return (
      <>
        <Card>
          <CardHeader className="Text-center" title="Facility Wound Report">
            <CardHeaderToolbar>
              <div className="example-tools"></div>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            {renderWoundForm()}
            <hr />
            {showReport && (
              <>
                <div className="row">
                  <div className="col-12 d-flex justify-content-end align-items-center mb-3">
                    <button
                      disabled={isPrinting}
                      type="button"
                      onClick={PrintElem}
                      className="btn btn-success btn-sm"
                    >
                      {isPrinting ? (
                        <Loader type="Puff" color="#000" height={15} width={15} />
                      ) : (
                        "Print Report"
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={handleExportExcel}
                      className="ml-3 btn btn-success btn-sm"
                    >
                      Export Report
                    </button>
                  </div>
                </div>
                <div id="printit" className="printDiv">
                  <WithGroupedWoundReports woundEvaluation={woundEvaluations} />
                </div>
                <canvas
                  id="fixedCanvas"
                  width="100"
                  height="100"
                  style={{ display: "none" }}
                ></canvas>
              </>
            )}
          </CardBody>
        </Card>
      </>
    );
  };
  